'use client';

import React from 'react';
import { MotionConfig } from 'framer-motion';

/**
 * Makes every Framer Motion animation on the site honour the visitor's
 * reduced-motion preference.
 *
 * Framer does not do this on its own. `reducedMotion="user"` makes it drop
 * transform and layout animations while keeping opacity ones, which is the
 * behaviour the WCAG guidance actually asks for — a fade is not a vestibular
 * trigger, a slide is. Seven section components animate on scroll; doing this
 * globally means none of them can be forgotten, including any added later.
 *
 * The CSS-driven motion (the headline reveal, the drawn connector, the section
 * rail) is covered separately by the reduced-motion block in tailwind.css.
 */
export default function MotionProvider({ children }: { children: React.ReactNode }) {
  return <MotionConfig reducedMotion="user">{children}</MotionConfig>;
}
